import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import tab from './modules/tab'

Vue.use(Vuex)

// 自动加载 modules 目录下的所有模块
const modulesFiles = require.context('./modules', false, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  modules,
  getters,
  tab
})

export default store